var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":"https://ucarecdn.com/cb5e87b7-d5cb-48c5-a679-3f579fcc2345/-/format/auto/","alt":"Deliverect Logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }